import { Overlay, OverlayPositionBuilder, OverlayRef } from '@angular/cdk/overlay';
import {
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  Injector,
  OnDestroy,
  ViewContainerRef,
  inject,
  input,
  DOCUMENT,
} from '@angular/core';
import { ComponentPortal } from '@angular/cdk/portal';
import { translation } from '@cue/translations';
import { cueNewReservation, IconComponent } from '@cue/ui/icons';
import { TranslocoPipe } from '@jsverse/transloco';

import { Subscription } from 'rxjs';
import {
  RESERVATION_OPTION_CLOSE,
  ReservationOptionComponent,
} from '../reservation-option/reservation-option.component';

@Component({
  selector: 'assist-layout-reserve-button',
  imports: [TranslocoPipe, IconComponent],
  templateUrl: './layout-reserve-button.component.html',
  styleUrls: ['./layout-reserve-button.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [Overlay],
})
export class LayoutReserveButtonComponent implements OnDestroy {
  private injector = inject(Injector);
  private container = inject(ViewContainerRef);
  private elementRef = inject(ElementRef);
  private overlay = inject(Overlay);
  private overlayPositionBuilder = inject(OverlayPositionBuilder);
  private document = inject<Document>(DOCUMENT);
  cueNewReservation = cueNewReservation;
  translation = translation;
  sub?: Subscription;
  primaryButton = input(true);

  private overlayRed?: OverlayRef;

  toggleOverlay() {
    if (this.overlayRed) {
      this.closeOverlay();
    } else {
      const originY = window.innerWidth <= 999.5 ? 'top' : 'bottom';
      const pxEMSize = parseFloat(getComputedStyle(this.container.element.nativeElement).fontSize);
      const padd = pxEMSize * 0.5;
      const offsetY = window.innerWidth <= 999.5 ? -1 * padd : padd;
      const overlayY = window.innerWidth > 999.5 ? 'top' : 'bottom';
      const position = this.overlayPositionBuilder.flexibleConnectedTo(this.elementRef.nativeElement).withPositions([
        {
          offsetY: offsetY,
          originX: 'end',
          originY: originY,
          overlayX: 'end',
          overlayY: overlayY,
        },
      ]);
      this.overlayRed = this.overlay.create({
        positionStrategy: position,
        hasBackdrop: true,
      });

      this.overlayRed.backdropClick().subscribe(() => this.closeOverlay());
      const reserveSubmenuPortal = new ComponentPortal(
        ReservationOptionComponent,
        null,
        Injector.create({
          parent: this.injector,
          providers: [
            {
              provide: RESERVATION_OPTION_CLOSE,
              useValue: () => this.closeOverlay(),
            },
          ],
        })
      );
      this.overlayRed.attach(reserveSubmenuPortal);
    }
  }

  private closeOverlay() {
    this.sub?.unsubscribe();
    this.sub = undefined;
    this.overlayRed?.dispose();
    this.overlayRed = undefined;
  }

  ngOnDestroy(): void {
    this.overlayRed?.dispose();
  }
}
